<header class="clearfix">

    <!-- Branding -->
    <div class="branding">
        <a class="brand" [routerLink]="['/']" [ngStyle]="{'background': getLogo() + 'no-repeat 0 10px'}">
            <span><strong>{{AppSettings.SITE_TITLE}}</strong></span>
        </a>
        <a role="button" tabindex="0" class="offcanvas-toggle visible-xs-inline"><i class="fa fa-bars"></i></a>
    </div>
    <!-- Branding end -->

    <!-- Left-side navigation -->
    <ul class="nav-left pull-left list-unstyled list-inline">
        <li class="sidebar-collapse divided-right">
            <a role="button" tabindex="0" class="collapse-sidebar">
                <i class="fa fa-outdent"></i>
            </a>
        </li>
    </ul>
    <div class="col-sm-3" style="width: 20%;">
    <div class="social-icons">
    <a href="javascript:history.back()" class="plus-export">
        <span class="glyphicon glyphicon-arrow-left"></span>  
      </a>
      </div>
    </div>

    <!-- Left-side navigation end -->

    <!-- Right-side navigation -->
    <ul class="nav-right pull-right list-inline">
        
        <li class="dropdown nav-profile">

            <a href class="dropdown-toggle" data-toggle="dropdown">
                {{ apiResponse?.profile_image }}
                <img *ngIf="apiResponse?.profile_image" [attr.src]="profileImage" alt="" class="img-circle size-30x30">
                <img *ngIf="!apiResponse?.profile_image" src="http://vmi313621.contaboserver.net/Software_backend/uploads/user_image/default-user-icon.png" alt="" class="img-circle size-30x30">
                <span>{{userName}} <i class="fa fa-angle-down"></i></span>
            </a>

            <ul class="dropdown-menu animated littleFadeInRight" role="menu">
                <li>
                    <a role="button" tabindex="0">
                         {{lang?.lastAccess + ' ' + lastLogin}}
                    </a>
                </li>
                <li class="divider"></li>
                <li>
                    <a role="button" tabindex="0" [routerLink]="['/'+AppFrontRoutes.PROFILE]">
                        <i class="fa fa-user"></i>{{language?.general.profile}}
                    </a>
                </li>
                <li>
                    <a role="button" tabindex="0" [routerLink]="['/'+AppFrontRoutes.TICKET_LIST]">
                        <i class="fa fa-headphones"></i>{{language?.general.support}}
                    </a>
                </li>
                <li>
                    <a role="button" tabindex="0" [routerLink]="['/'+AppFrontRoutes.SETTINGS]">
                        <i class="fa fa-gear"></i>{{lang?.settings}}
                    </a>
                </li>
                <li class="divider"></li>
                <li>
                    <a role="button" tabindex="0" (click)="logout()">
                        <i class="fa fa-sign-out"></i>{{lang?.logout}}
                    </a>
                </li>

            </ul>

        </li>

    </ul>
    <!-- Right-side navigation end -->



</header>